import React, { Component } from "react";
import { I18n } from 'aws-amplify';
import { formatMoney2 } from '../../../utils/helpers'
import {
    Row,
    Col,
    Form,
    Icon,
    Spin,
    Input,
    InputNumber,
    Select,
    Button
} from 'antd';

import styled from 'styled-components';

const { Option } = Select;

const BoxSpin = styled.div`
  text-align: center;
  border-radius: 4px;
  margin-bottom: 20px;
  padding: 30px 50px;
`

const FormBox = styled(Form)`

`

class Proposal extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.setState({
                    formState: values,
                })
                
                this.props.action(values);
            }
        });
    };

    componentDidUpdate(prevProps, prevState) {

        if (!prevProps) return;
        if (!prevState) return;

        if (this.props.errors != prevProps.errors && this.props.errors) {
            Object.keys(this.props.errors).map(field => {
                this.props.form.setFields({
                    [field]: {
                        value: this.state.formState[field],
                        errors: [new Error(this.props.errors[field].errorMessage)],
                    },
                });
            });
        }
     }


     renderAction = (item) => {
        if(Object.keys(item).length > 0) {
            return I18n.get("Editar");
        } else {
            return I18n.get("Adcionar");
        }
     }


    render() {
        const { getFieldDecorator, getFieldValue } = this.props.form;
        const { filters } = this.props

        const {item = {}} = this.props;
        
        // if (!filters) {
        //     return (
        //         <BoxSpin>
        //             <Spin />
        //         </BoxSpin>
        //     )
        // }


        return (
            <FormBox onSubmit={this.handleSubmit}>
                <Row>
                    <Col sm={18}>
                        <Form.Item
                            label={I18n.get("Asset")}>
                            {getFieldDecorator('asset', {
                                rules: [{ required: false, message: 'ops!' }],
                                initialValue: item.name || "",
                            })(
                                <Select
                                    showSearch={true}
                                    // mode="tags"
                                    style={{ width: '100%' }}
                                    tokenSeparators={[',']}
                                    filterOption={(input, option) =>
                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {this.props.assets && this.props.assets.map((item,index) => {
                                        return <Option value={item.code} key={item.code}>{item.label} --- {formatMoney2(item.price)}</Option>
                                    })}
                                </Select>
                            )}
                        </Form.Item>
                    </Col>
                    <Col sm={4}>
                        <Form.Item
                            label={I18n.get("Quantidade")}>
                            {getFieldDecorator('qnt', {
                                rules: [{ required: false, message: 'ops!' }],
                                initialValue: 1,
                            })(
                                <InputNumber min={1} defaultValue={1} />
                            )}
                        </Form.Item>
                    </Col>
                    <Col sm={24}>
                            <Button
                                className="button bt-bpool black"
                                shape="round"
                                htmlType="submit"
                                // disabled={!filters || getFieldValue("clientId") == ""}
                                loading={this.props?.task?.busy}
                            >
                               {I18n.get("Adicionar")} 
                            </Button>
                    </Col>
                </Row>

            </FormBox>
        )
    }
}



const FormProposal = Form.create({})(Proposal);

export default FormProposal;

